import http from "../plugins/axios";
const BASE_URI = "/advice-detail";
export default {
  getAdviceDetailPagination({
    limit,
    currentPage,
    searchByTitle,
    searchByTopic,
    searchByDegreeType
  }) {
    return http.get(
      `${BASE_URI}?limit=${limit}&currentPage=${currentPage}&searchByTitle=${searchByTitle}&searchByTopic=${searchByTopic}&searchByDegreeType=${searchByDegreeType}`
    );
  },
  getDetail(id) {
    return http.get(`${BASE_URI}/${id}`);
  },
  create(data) {
    return http.post(`${BASE_URI}`, data);
  },
  update(data) {
    const { id } = data;
    return http.put(`${BASE_URI}/${id}`, data);
  },
  remove(id) {
    return http.delete(`${BASE_URI}/${id}`);
  }
};
